export default __webpack_public_path__ + "assets/list-bullet.86a14f43.svg";